module.exports = __webpack_public_path__ + "static/media/attach_zip.a0d87074.png";